module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./TransferDetailView.js"));
	}, "TransferDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=TransferDetailView!./src/pages/Promote/OfflineActivity/EnterActivity/TransferDetail/TransferDetailView.js
// module id = 1173
// module chunks = 431